/**
 * Password requirements following NIST SP 800-63B guidelines
 * Single source of truth for both server and client validation
 */

export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 64

export const PASSWORD_HINT_TEXT = 'Minimum 8 characters.'
